<template>
  <div id="app">
    <!-- <router-view/> -->
    <keep-alive>
      <router-view v-if="this.$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!this.$route.meta.keepAlive"/>

  </div>
</template>
<script>
import {Dialog} from "vant";

export default {
  beforeCreate() {
    if (!localStorage.getItem('user_token') && sessionStorage.getItem('edit') == undefined) {
      sessionStorage.setItem('edit', 'true')
    }
  },
  created() {
    this.changeFavicon()
  },
  mounted() {
    window.addEventListener('offline', this.onOffline, false);
  },
  destroyed() {
    window.removeEventListener('offline', this.onOffline);
  },
  methods: {
    changeFavicon() {
      this.$post('article/icon').then(result => {
        document.title = result.data.name;
        let favicon = document.createElement('link');
        favicon.rel = 'icon';
        favicon.href = result.data.icon;
        document.head.appendChild(favicon);
      });
    },
    onOffline() {
      Dialog.alert({
        title: "提示",
        message: "网络开小差，请稍后再试",
        confirmButtonColor: '#126AFC',
      })
    }
  }
}
</script>
<style lang="less">
.hint {
  margin-top: 10vh;
  text-align: center;
}
</style>
